import { useEffect } from "react";
import "../Common/css/styles.css";
import text from "../Assets/Text/Text.json";
import { useNavigate } from "react-router-dom";
import React from "react";

export const InstructorCourses = () => {
    const instructorSubjects = JSON.parse(sessionStorage.getItem("instructorSubjects") || "[]");
    const navigate = useNavigate();

    useEffect(() => {
        // Optional setup
    }, []);

    const handleCourseClick = (course: string, programme : string) => {
        navigate("/instructor/instructor-subject", { state: { course } });
        sessionStorage.setItem("instructor-course", course);
        sessionStorage.setItem("instructor-programme", programme);
    };

    // Separate lists
    const alevels = instructorSubjects.filter((item: any) => item.programme === "Fast track A/L");
    const diplomaCourses = instructorSubjects.filter((item: any) => item.programme === "Diploma");
    const certificateCourses = instructorSubjects.filter((item: any) => item.programme === "Certificate course");

    return (
        <div className="comman-outer">
            <div className="comman-header-outer">
            </div>

            {alevels.length > 0 && (
                <div className="courses-section">
                    <h3 style={{ color: "white" }}>Fast Track A/L</h3>
                    <div className="courses-container">
                        {alevels.map((item: any, index: number) => {
                            const courseName = item.subject || item.stream || "Unknown Course";
                            return (
                                <div
                                    key={index}
                                    className="course-card2"
                                    onClick={() => handleCourseClick((item.stream+" : "+courseName),"Fast Track A/L")}
                                >
                                    <h3>{item.stream}</h3>
                                    <p>Subject: {courseName}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            <div className="space"></div>
            <div className="space"></div>

            {diplomaCourses.length > 0 && (
                <div className="courses-section">
                    <h3 style={{ color: "white" }}>Diploma Courses</h3>
                    <div className="courses-container">
                        {diplomaCourses.map((item: any, index: number) => {
                            const courseName = item.subject || item.stream || "Unknown Course";
                            return (
                                <div
                                    key={index}
                                    className="course-card2"
                                    onClick={() => handleCourseClick(courseName+" : "+courseName, "Diploma")}
                                >
                                    <h3>{item.stream}</h3>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}


            <div className="space"></div>
            <div className="space"></div>

            {certificateCourses.length > 0 && (
                <div className="courses-section">
                    <h3 style={{ color: "white" }}>Certificate Courses</h3>
                    <div className="courses-container">
                        {certificateCourses.map((item: any, index: number) => {
                            const courseName = item.subject || item.stream || "Unknown Course";
                            return (
                                <div
                                    key={index}
                                    className="course-card2"
                                    onClick={() => handleCourseClick(courseName+" : "+courseName, "Certificate Course")}
                                >
                                    <h3>{item.stream}</h3>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};
